export const getInsurancePremium = function (
  sumInsured: number,
  clauseRate: number
) {
  //   Premium = sum insured * (clause rate %)
  const premium = sumInsured * (clauseRate / 100);
  return premium;
};
